export const copyToClipboardAsync = async (
  fetchData: () => Promise<string>
): Promise<boolean> => {
  if (typeof ClipboardItem !== "undefined" && navigator.clipboard) {
    const textPromise = fetchData().then(
      (value) => new Blob([value], { type: "text/plain" })
    );

    const clipboardItem = new ClipboardItem({ "text/plain": textPromise });
    try {
      await navigator.clipboard.write([clipboardItem]);
      return true;
    } catch (e) {
      console.error("Failed to add clipboard async: ", e);
      return false;
    }
  }

  try {
    const value = await fetchData();
    await navigator.clipboard.writeText(value);
    return true;
  } catch (e) {
    console.error("Failed to add clipboard async: ", e);
    return false;
  }
};
